import React from 'react';
import { Breadcrumbs } from './Breadcrumbs';
import { DiagonalAccent } from './DiagonalAccent';
import type { Crumb, SiteImage } from '../../types/content';
interface PageHeroProps {
  title: string;
  intro?: string;
  image: SiteImage;
  breadcrumbs: Crumb[];
  imagePosition?: string;
  children?: React.ReactNode;
}
export function PageHero({
  title,
  intro,
  image,
  breadcrumbs,
  imagePosition = '70% center',
  children
}: PageHeroProps) {
  return <section className="relative isolate overflow-hidden bg-charcoal-950" data-id="element-557" data-mp="1cahz1tz1b9z5">
      <img src={image.src} alt="" className="absolute inset-0 -z-20 h-full w-full object-cover" style={{
      objectPosition: imagePosition
    }} loading="eager" data-id="element-558" data-mp="17e1168219h8v" />
      <div className="absolute inset-0 -z-10 bg-charcoal-950/75 md:bg-charcoal-950/55" aria-hidden="true" data-id="element-559" data-mp="xes8rjmtgaom" />
      <div className="mx-auto flex min-h-[360px] max-w-site flex-col justify-end px-5 pb-14 pt-14 md:min-h-[440px] md:px-8 md:pb-20" data-id="element-560" data-mp="3n5x9fqxiu70r">
        <Breadcrumbs items={breadcrumbs} data-id="element-561" data-mp="2t40bb6tngr0l" />
        <h1 className="mt-6 max-w-4xl font-display text-[44px] font-extrabold uppercase leading-[0.92] text-white md:text-[68px]" data-id="element-562" data-mp="2t5bhteehccve">
          {title}
        </h1>
        {intro && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-steel-100 md:text-xl" data-id="element-563" data-mp="2j6c6tp68s558">{intro}</p>}
        {children}
      </div>
      <div className="absolute bottom-0 left-0 right-0 flex h-1.5" aria-hidden="true" data-id="element-564" data-mp="2o3m23lgbbb0z">
        <span className="w-1/3 bg-brand-red" data-id="element-565" data-mp="2ach9v4f9xl0o" />
        <span className="flex-1 bg-charcoal-700" data-id="element-566" data-mp="2abnzzul0qfeb" />
      </div>
      <DiagonalAccent className="absolute bottom-6 right-5 hidden h-8 w-24 md:block md:right-8" data-id="element-567" data-mp="2f50p05tm0o7l" />
    </section>;
}